<template>
    <section class="relative mt-6 md:mt-10 lg:mt-12 | xl:mt-7">
        <div class="container">
           <label class="search-input">
               <span class="search-input__field"
                     :class="{ 'search-input__field--no-empty' : search !== null && search.length > 0 }"
               >
                   <input
                       type="text"
                       placeholder="Search"
                       v-model="search"
                       @input="searchQuestion"
                   >
                   
                    <span @click="clearSearch" class="search-input__field__btn">
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 0.824833L13.1752 0L7 6.17517L0.824833 0L0 0.824833L6.17517 7L0 13.1752L0.824833 14L7 7.82483L13.1752 14L14 13.1752L7.82483 7L14 0.824833Z" fill="#6A7787"/>
                      </svg>
                    </span>
               </span>
               
               <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                   <path d="M18.7808 17.7203L14.3041 13.2436C15.524 11.7515 16.1239 9.84764 15.9795 7.92574C15.8351 6.00384 14.9575 4.21097 13.5283 2.91796C12.099 1.62495 10.2275 0.930738 8.3008 0.978912C6.37409 1.02709 4.5396 1.81396 3.17678 3.17678C1.81396 4.5396 1.02709 6.37409 0.978912 8.3008C0.930738 10.2275 1.62495 12.099 2.91796 13.5283C4.21097 14.9575 6.00384 15.8351 7.92574 15.9795C9.84764 16.1239 11.7515 15.524 13.2436 14.3041L17.7203 18.7808C17.8618 18.9174 18.0512 18.993 18.2479 18.9913C18.4445 18.9896 18.6326 18.9107 18.7717 18.7717C18.9107 18.6326 18.9896 18.4445 18.9913 18.2479C18.993 18.0512 18.9174 17.8618 18.7808 17.7203ZM8.50057 14.5006C7.31388 14.5006 6.15384 14.1487 5.16715 13.4894C4.18045 12.8301 3.41142 11.893 2.95729 10.7967C2.50317 9.70031 2.38435 8.49391 2.61586 7.33003C2.84737 6.16614 3.41881 5.09704 4.25793 4.25793C5.09704 3.41881 6.16614 2.84737 7.33003 2.61586C8.49391 2.38435 9.70031 2.50317 10.7967 2.95729C11.893 3.41142 12.8301 4.18045 13.4894 5.16715C14.1487 6.15384 14.5006 7.31388 14.5006 8.50057C14.4988 10.0913 13.8661 11.6164 12.7412 12.7412C11.6164 13.8661 10.0913 14.4988 8.50057 14.5006Z" fill="#ABB4BF"/>
               </svg>
           </label>
            
            <div class="w-full mx-auto flex flex-col lg:max-w-[902px] xl:max-w-[830px]">
                <div v-for="(question, index) in currentQuestions" :key="`question-${question.heading}`"
                     class="fade-up accordion relative cursor-pointer mb-8 last:mb-0 transition-colors md:mb-10 lg:mb-12"
                     :class="{'!border-blue' : activeArray.includes(index)}"
                     @click="addAccordionToArray(index)"
                >
                   <div class="flex justify-between border-b border-solid border-darkblue-200 pb-4 md:border-darkblue md:pb-6">
                       <h5 class="text-h5 mr-11">{{question.heading}}</h5>

                       <svg :class="{'rotate-180' : activeArray.includes(index) }" class="block flex-shrink-0 mt-2 transform transition-transform duration-300" width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                           <path d="M13.7098 1.20986C13.6169 1.11613 13.5063 1.04174 13.3844 0.990969C13.2625 0.9402 13.1318 0.914062 12.9998 0.914062C12.8678 0.914062 12.7371 0.9402 12.6152 0.990969C12.4934 1.04174 12.3828 1.11613 12.2898 1.20986L7.70982 5.78985C7.61685 5.88358 7.50625 5.95797 7.38439 6.00874C7.26253 6.05951 7.13183 6.08565 6.99982 6.08565C6.86781 6.08565 6.7371 6.05951 6.61524 6.00874C6.49338 5.95797 6.38278 5.88358 6.28982 5.78985L1.70982 1.20986C1.61685 1.11613 1.50625 1.04174 1.38439 0.990969C1.26253 0.9402 1.13183 0.914062 0.999816 0.914062C0.867804 0.914062 0.737098 0.9402 0.615239 0.990969C0.49338 1.04174 0.382779 1.11613 0.289816 1.20986C0.103565 1.39722 -0.000976562 1.65067 -0.000976562 1.91486C-0.000976562 2.17904 0.103565 2.4325 0.289816 2.61986L4.87982 7.20985C5.44232 7.77165 6.20481 8.08721 6.99982 8.08721C7.79482 8.08721 8.55732 7.77165 9.11982 7.20985L13.7098 2.61986C13.8961 2.4325 14.0006 2.17904 14.0006 1.91486C14.0006 1.65067 13.8961 1.39722 13.7098 1.20986Z" fill="#516783"/>
                       </svg>
                   </div>
                    
                    <slide-up-down :active="activeArray.includes(index)" :duration="500">
                       <div class="overflow-hidden w-full">
                           <div class="wysiwyg text-2 my-4" v-html="question.content"></div>
                       </div>
                   </slide-up-down>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import SlideUpDown from 'vue-slide-up-down'
export default {
    name: "faq",
    props: ['data'],
    components: { SlideUpDown },
    data() {
        return {
            questions: JSON.parse(this.data),
            search: null,
            currentQuestions: null,
            activeArray: [],
        }
    },
    methods: {
        searchQuestion() {
            let questions = this.questions;
            
            questions = questions.filter(question => {
                if ( this.search !== '' && this.search !== null  ) {
                    if (
                        question.heading.toLowerCase().includes(this.search.toLowerCase()) ||
                        question.content.toLowerCase().includes(this.search.toLowerCase()) 
                    ) {
                        return question
                    }
                }
                else {
                    return question;
                }
            })
            
            this.currentQuestions = questions;
        },
        addAccordionToArray(tab) {
            if ( !this.activeArray.includes(tab) ) {
                this.activeArray.push(tab);
            }
            else {
                this.activeArray.splice(this.activeArray.indexOf(tab), 1);
            }
        },
        clearSearch() {
            this.search = null;
            this.searchQuestion();
        }
    },
    mounted() {
        this.searchQuestion();
    }
}
</script>

<style scoped lang="scss">
    .fade-up {
        animation: fadeAnim .5s ease both;
        @keyframes fadeAnim {
            from {
                opacity: 0;
            }
            to {
                opacity: 100%;
            }
        }
    }
</style>